import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { UserProfileResponse, UserType } from 'api/minside';
import { Link } from 'react-router-dom';
import RoutePaths from 'RoutePaths';
import { useTranslation } from 'react-i18next';
import { UserProperty } from './UserProperty';

import './UserData.scss';

export type IProps = {
  user: UserProfileResponse;
  onDeletePhone?: () => void;
  onChangeName?: () => void;
};

function Employer(user: UserProfileResponse) {
  const { t } = useTranslation('components');

  if (user.userType === UserType.Internal) {
    return <>{user.employer}</>;
  }
  if (user.employer === 'UTLA') {
    return (
      <>
        {t('profile.employer.foreign')} (
        <Link to={RoutePaths.profileConfigureEmployer}>{t('profile.employer.change')}</Link>)
      </>
    );
  }
  return user.employer ? (
    <>
      {user.employer} (<Link to={RoutePaths.profileConfigureEmployer}>{t('profile.employer.change')}</Link>)
    </>
  ) : (
    <Link to={RoutePaths.profileConfigureEmployer}>{t('profile.employer.choose')}</Link>
  );
}


export function UserData({ user, onChangeName }: IProps) {
  const { t } = useTranslation('components');

  function renderUserName() {
    if (user.userType === UserType.Internal) {
      return user.name;
    }
    return (
      <>
        {user.name}
        <span
         className='span-button'
         onClick={() => onChangeName && onChangeName()}
         >

          ({t('profile.employer.change')})
          </span>
      </>
    );
  }

  return (
    <div className='user-data-container'>
      <Row>
        <Col lg='8'>
          <UserProperty label={t('profile.userData.nameLabel')} value={renderUserName()} />
          {/* <UserProperty label='Telefon' value={user.telefonNr} /> */}
          <UserProperty label={t('profile.userData.emailUsernameLabel')} value={user.email} />
          <UserProperty label={t('profile.userData.employerLabel')} value={Employer(user)} />
          {user.statsforvalterenOrganizationGroup?.organizations?.length && (
            <UserProperty
              label={t('profile.userData.statsforvalterenBranchLabel')}
              value={user.statsforvalterenOrganizationGroup.organizations[0].name}
            />
          )}
          {user.mfaPhoneNumber && user.userType === UserType.External && (
            <UserProperty
              label={t('profile.userData.telephoneLabel')}
              value={`${user.mfaPhoneNumber} ${t('profile.userData.telephoneMfaDisclaimer')}`}
            />
          )}
        </Col>
      </Row>
    </div>
  );
}
